import React from 'react'
import { FaLinkedinIn } from 'react-icons/fa'
import { VscGithub } from 'react-icons/vsc'
import { FaXTwitter,FaInstagram } from 'react-icons/fa6'
import {
  AiOutlineRead
} from 'react-icons/ai'

const externalLinkList = [
  {
    id: 1,
    icon: <FaLinkedinIn />,
    url: 'www.linkedin.com/in/kaedenakashima',
  },
  {
    id: 2,
    icon: <FaXTwitter />,
    url: 'https://x.com/KaedeNakashima',
  },
  {
    id: 3,
    icon: <VscGithub />,
    url: 'https://github.com/kaedenakashima'
  },
  {
    id: 4,
    icon: <FaInstagram />,
    url: 'https://www.instagram.com/katie_the_lazyone2'
  }
]
const footer = () => {
  return (
    <footer>
      <div className='left-block'>
        <div className='external-link flex'>
          {externalLinkList.map(iconLink => {
            return (
              <a
                key={iconLink.id}
                href={iconLink.url}
              >
                {iconLink.icon}
              </a>
            )
          })}
        </div>
        <div className='honourCode_Phone'>
          <div className="text"><b>Following Professional Developer Rules</b><br />I respect web applications created by other developers. When I publish my products in public,  I will not use other one’s code for my products.</div>
        </div>
        <p className='copyright'>Copyright {new Date().getFullYear()} All rights reserved to Kaede Nakashima.</p>
      </div>
      <div className='honourCode_PC'>
        <div className="text"><b><u>Following Professional Developer Rules</u></b><br />I respect web applications created by other developers. When I publish my products in public, I will not use other one’s code for my products.</div>
      </div>
    </footer>
  )
}

export default footer;
